import React from 'react';
import { useChatContext } from 'stream-chat-react';
import { findLast } from '../utils/index.js';

const MARK_READ = "notification.mark_read";
const MARK_UNREAD = "notification.mark_unread";
const EVENTS = [MARK_READ, MARK_UNREAD];
const useChannelUnread = (channel, unread, refreshTotalUnreadCount) => {
    const { client } = useChatContext();
    const [unreadCount, setUnreadCount] = React.useState(unread);
    const initialRenderRef = React.useRef(true);
    React.useEffect(() => {
        setUnreadCount(unread);
        if (initialRenderRef.current) {
            initialRenderRef.current = false;
        }
        else {
            refreshTotalUnreadCount();
        }
    }, [unread]);
    React.useEffect(() => {
        const updateUnread = (event) => {
            var _a, _b;
            if (event.cid !== channel.cid)
                return;
            if (((_a = event.user) === null || _a === undefined ? undefined : _a.id) !== ((_b = client.user) === null || _b === undefined ? undefined : _b.id))
                return;
            const count = event.type === MARK_READ ? 0 : channel.countUnread();
            setUnreadCount(count);
        };
        EVENTS.forEach((event) => client.on(event, updateUnread));
        return () => EVENTS.forEach((event) => client.off(event, updateUnread));
    }, []);
    const lastReadMessage = React.useMemo(() => findLast(channel.state.latestMessages, (msg) => { var _a; return ((_a = msg.user) === null || _a === undefined ? undefined : _a.id) !== client.userID; }), [unreadCount]);
    const isUnreadable = Boolean(lastReadMessage === null || lastReadMessage === undefined ? undefined : lastReadMessage.id);
    return {
        isUnread: Boolean(unreadCount),
        isUnreadable,
        markRead: async () => await channel.markRead(),
        markUnread: async () => isUnreadable &&
            (await channel.markUnread({ message_id: lastReadMessage.id })),
        unreadCount,
    };
};

export { useChannelUnread };
//# sourceMappingURL=use_channel_unread.js.map
